<template>
    <work-order-detail v-bind="$props" />
</template>

<script setup>
import WorkOrderDetail from '@/Pages/WorkOrders/WorkOrderDetail.vue';

// Thin wrapper kept for the legacy single work-order external route (and existing Inertia
// component assertions). All behaviour lives in WorkOrderDetail; the legacy defaults
// (centered card, own footer, window close) apply automatically.
defineProps({
    workOrder: {
        type: Object,
        required: true,
    },
    external: Boolean,
    externalTabToken: { type: String, default: null },
    workOrderHistory: Array,
    statuses: {
        type: [Object, null],
        required: true,
    },
    priorities: {
        type: [Object, null],
        required: true,
    },
    assignees: {
        type: [Array, null],
        required: true,
    },
    isEditable: {
        type: Boolean,
        required: true,
    },
    canReassign: {
        type: Boolean,
        default: true,
    },
    canUpdateAssetOperability: {
        type: Boolean,
        default: false,
    },
    workOrderPropertyConfig: {
        type: Object,
        default: () => ({}),
    },
    impactAssessment: { type: Object },
    catsaExtras: { type: Object },
    msdNotification: { type: Object },
    defaultContactPhone: { type: [String, null], default: null },
    caseCategories: { type: Array, default: () => [] },
    inoperableReminderKey: { type: [String, null], default: null },
});
</script>
